import Square from './square';
// import pureHttp from '@/libs/base/pureHttp';
import { http } from '@/libs/interfaces'

let squareInstance = null;

export default async function createSquare(unionid, openid, callback) {
  if (squareInstance) {
    return;
  }

  // const res = await pureHttp.get('https://m.ktvsky.com/c0/config/pushconfig', {
  //   params: {
  //     unionid,
  //     openid,
  //   },
  // });
  const res = await http.get('https://m.ktvsky.com/c0/config/pushconfig?BaseUrlType=other', {
    params: {
      unionid,
      openid,
    },
  })
  if (res.data && res.errcode === 200) {
    squareInstance = new Square({
      server: `${res.data.schema}://${res.data.addr}:${res.data.port}`,
      unionid,
      openid,
    });
    await squareInstance.createConnect();
    squareInstance.subscribe();
    squareInstance.receiveMsg(callback);
  }
}
